import { Box, Container, Link, List, Typography, CircularProgress } from '@mui/material'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import React, { useEffect, useState } from 'react'
import { NavLink, redirect, useNavigate } from 'react-router-dom'
// import logoHeader from "assets/images/color-logo.svg";
import logoHeader from "assets/images/home-page-images/TavloAI.png";

import landingone from "assets/images/Vector21.svg";
import landingtwo from "assets/images/Vector22.svg";
import dashboardHero from "assets/images/center-img.png";
import landingfour from "assets/images/Group20.svg";
import landingfive from "assets/images/Group21.svg";
import bgpattern from "assets/images/Clip_Path_group.svg";
import ellipse from "assets/images/Ellipse3.svg";
import styled from "@emotion/styled";
import composeAdorn from "assets/images/graph.svg";
import star from "assets/images/Vector.svg";
import agrRev1 from "assets/images/agr-rev-1-shadow-n.png";
import ReCAPTCHA from 'react-google-recaptcha'
import { useDispatch, useSelector } from "react-redux";
import { clearGoogleAddress } from "features/reducers/auth";
import { clearRegister } from "features/reducers/auth";
import { GoogleSearchAysnc, registerUserAsync, googleLoginUserAsync } from 'features/actions/auth'
import InputMask from "react-input-mask";
import showHideIcon from "assets/images/small-logos/show-hide-icon.svg";
import dontShowIcon from "assets/images/small-logos/dont-show.svg";
import correctIcon from "assets/images/small-logos/icon-right.svg";
import wrongIcon from "assets/images/small-logos/wrong-icon.svg";
import Footer from 'layouts/home/components/footer'
import tickIcon from "assets/images/small-logos/blue-tick.svg";
import { PaddingOutlined } from '@mui/icons-material'
import { useGoogleLogin } from '@react-oauth/google';
import Loader from 'assets/loader/loader'
import icon from "assets/images/google.png";
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display'


const Landing = () => {
    const [open, setOpen] = React.useState(false);
    const [isLocalhost, setIsLocalhost] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getAllRestaurants, googleAddress, registerData } = useSelector(
        (state) => state.auth
    );
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [businessNameHint, setBusinessNameHint] = useState([]);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [googleApiCall, setGoogleApiCall] = useState(false);
    const [values, setValues] = useState({
        email: "",
        first_name: "test",
        last_name: "user",
    });
    const [filterDataClose, setFilterDataClose] = useState(false);
    const [errors, setErrors] = useState({
        email: "",
        first_name: "",
        last_name: "",
    });
    const checkName = /^[a-zA-Z\s]+$/;
    const checkEmail = /\S+@\S+\.\S+/;
    const login = useGoogleLogin({
        onSuccess: async tokenResponse => {
            try {
                setLoading(true);
                await dispatch(googleLoginUserAsync(tokenResponse.access_token));
                navigate("/dashboard");
            } catch (error) {
                console.log(error);
            }
        },
        onNonOAuthError: () => {
            setLoading(false);
        },
        onError: (error) => {
            setLoading(false);
            console.log(error);
        }
      });
    const handleCaptchaChange = (value) => {
        setIsCaptchaVerified(true);
    };
    const handleRemoveMaskingChars = (phone_number) => {
        const cleanedPhoneNumber = phone_number.replace(/\D/g, ""); // Remove non-numeric characters
        return cleanedPhoneNumber;
    };
    const validateForm = (formData) => {
        const newErrors = {};
        const trimmedEmail = formData?.email?.trim();
        const trimmedFirstName = formData?.first_name?.trim();
        const trimmedLastName = formData?.last_name?.trim();
        // Validate email
        if (!trimmedEmail) {
            newErrors.email = "Email is required";
        } else if (!checkEmail.test(trimmedEmail)) {
            newErrors.email = "Invalid email format";
        }
        // Validate name
        if (!trimmedFirstName) {
            newErrors.first_name = "First name is required";
        } else if (!checkName.test(trimmedFirstName)) {
            newErrors.first_name = "First name must be in alphabetic characters";
        }
        if (!trimmedLastName) {
            newErrors.last_name = "Last name is required";
        } else if (!checkName.test(trimmedLastName)) {
            newErrors.last_name = "Last name must be in alphabetic characters";
        }

        return newErrors;
    };

    const inputHandler = (fieldName) => {
        return (e) => {
            const { name, value } = e.target;
            let error = "";

            switch (fieldName) {
                case "email":
                    if (!value) {
                        error = "Email is required";
                    } else if (!checkEmail.test(value)) {
                        error = "Invalid email format";
                    }
                    break;
                case "first_name":
                    if (!value) {
                        error = "First name is required";
                    } else if (!checkName.test(value)) {
                        error = "First name must be in alphabetic characters";
                    }
                    break;
                case "last_name":
                    if (!value) {
                        error = "Last name is required";
                    } else if (!checkName.test(value)) {
                        error = "Last name must be in alphabetic characters";
                    }
                    break;

                // case "business_google_page":
                // case "business_yelp_page":
                // case "business_fb_page":
                // case "business_twitter_page":
                //     if (value && !checkUrl.test(value)) {
                //         error = "Invalid URL format";
                //     }
                //     break;
                // default:
                //     break;
            }
            setErrors({ ...errors, [fieldName]: error });
            setValues({ ...values, [fieldName]: value });
        };
    };

    const handleSubmit = async () => {
        const errors = validateForm(values);
        if (Object.keys(errors).length === 0) {
            setLoading(true);
            const formDataObject = new FormData();
            // Append trimmed and validated values to formDataObject
            Object.keys(values).forEach((key) => {
                formDataObject.append(key, values[key].trim());
            });

            try {
                await dispatch(registerUserAsync(formDataObject));
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        } else {
            setErrors(errors);
        }
    };
    useEffect(() => {
        if (registerData.status_code == 200) {
            localStorage.setItem("email", values.email);
            dispatch(clearRegister());
            dispatch(clearGoogleAddress());
            navigate("/thank-you");
        }
    }, [registerData]);
    useEffect(() => {
        if (!filterDataClose && values.businessName != "") {
            let filteredRestaurants =
                values.businessName != "" &&
                getAllRestaurants?.filter((restaurant) =>
                    restaurant.toLowerCase().includes(values.businessName.toLowerCase())
                );
            setBusinessNameHint(filteredRestaurants);
        }
    }, [filterDataClose, values]);
    useEffect(() => {
        if (filterDataClose && values.businessName != "" && !googleApiCall) {
            dispatch(GoogleSearchAysnc(values.businessName));
            setGoogleApiCall(true);
        }
    }, [values, filterDataClose]);

    useEffect(() => {
        if (googleAddress.status == "OK") {
            setValues({
                ...values,
                business_address: googleAddress.results[0].formatted_address,
            });
        }
    }, [googleAddress]);

    useEffect(() => {
        const isLocal =
            window.location.hostname === "localhost"
        setIsLocalhost(isLocal);
    }, []);


    const StyledListItem = styled.li`
    border-left: 4px solid #318bec;
    background-color: #ffffff;
    box-shadow: 0px 16px 50px 0px #b9c0c933;
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
    margin-bottom: 17px;
    padding-left: 1rem;
    padding-right: 1rem;
    width:"100%";`;
    const StyledListText = styled.p`
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
    color: #6b6b6b; `;
    const StyledListTextColor = styled.p`
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    color: #318BEC;  `;


    return (<>
        <Box sx={{
            position: "relative"
        }} >
            {loading && <Loader />}
            <Container
                sx={{ "@media (min-width:1580px)": { maxWidth: "1600px!important" } }}
            >
                <Box container sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    py: 1, "@media(max-width: 720px)": {
                        px: 2
                    },
                }}>
                    <MDBox sx={{
                        width: "100%", margin: "auto", textAlign: "start",
                    }}>
                        <NavLink to="/">
                            <MDBox
                  component="img"
                  src={logoHeader}
                  alt="background"
                  sx={{
                    width: {
                      xs: "117px",
                      sm: "95%",
                      md: "190px",
                    },

                    height: {
                      xs: "26px",
                      sm: "657px",
                      md: "auto",
                    },
                  }}
                />
                        </NavLink>
                    </MDBox>
                    <MDButton
                        component={Link}
                        sx={{
                            background: "#318BEC",
                            color: "#fff",
                            border: "2px solid #318BEC",
                            padding: "9px 40px 9px 40px",
                            borderRadius: "188px",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            textAlign: "left",
                            fontFamily: "urbanist",
                            textTransform: "none",
                            "&:hover": {
                                background: "#318BEC",
                            },
                        }}
                        onClick={() => navigate("/sign-in")}
                    >
                        Login
                    </MDButton>
                </Box>
            </Container>
        </Box>
        {/* section -1  */}
        <Container
            sx={{ "@media (min-width:1580px)": { maxWidth: "1600px!important" } }}
        >
            <Box
                sx={{
                    pt: 4, position: "relative", "@media (min-width:1580px)": { maxWidth: "1920px!important" }, "@media(max-width: 720px)": {
                        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                    },
                }}
            >
                <MDBox sx={{
                    with: "100vw",
                    position: "absolute", top: 0, left: 0, "@media(max-width: 720px)": {
                        display: "none",
                    },
                    "@media(max-width: 1440px)": {
                        display: "none",
                    },
                }}>
                    <img src={bgpattern} alt="background pattern" />
                </MDBox>
                <Box sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between", gap: "30px",
                    py: 1, "@media(max-width: 720px)": {
                        px: 0,
                        width: "100%",
                        display: "flex",
                        flexDirection: "column"
                    },
                }}>
                    <MDBox sx={{
                        position: "relative",
                        background: "#D0E5FA",
                        width: "745px",
                        Height: "465px",
                        borderTopRightRadius: "50px",
                        borderBottomRightRadius: "50px",
                        padding: "30px",
                        "@media(max-width: 720px)": {
                            borderRadius: "20px",
                            px: 2,
                            py: 2
                        },
                    }}>
                        <MDTypography sx={{
                            color: "#212121",
                            fontSize: "50px",
                            lineHeight: "60px",
                            fontWeight: "700",
                            textAlign: "left",
                            fontFamily: "Urbanist",
                            "@media(max-width: 720px)": {
                                fontSize: "25px",
                                lineHeight: "30px",
                                textAlign: "center",
                                my: 2,
                            },
                        }}>
                            The <span style={{ color: "#318BEC" }}>#1 AI Tool</span> Built for Restaurants and Bars
                        </MDTypography>
                        <MDBox
                            sx={{
                                marginBottom: "24px",
                                width: "100%",
                                textAlign: "center",
                                "@media (min-width:786px)": { flexDirection: "row" },
                                flexDirection: "column",
                            }}
                        >
                            <MDBox
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    flexDirection: "row", // Always row (icon + text side by side)
                                    mr: 2,
                                    my: 2,
                                    "@media(max-width: 720px)": {
                                        mr: 0,
                                        my: 0,
                                        alignItems: "flex-start",
                                        marginBottom: "10px"
                                    },
                                }}
                            >
                                <MDBox
                                    sx={{
                                        mr: 1,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img src={tickIcon} alt="tick icon" />
                                </MDBox>

                                <MDBox
                                    sx={{
                                        textAlign: "start", // left-align the text
                                        "@media(max-width: 720px)": {
                                            width: "100%",
                                            fontSize: "15px",
                                        },
                                    }}
                                >
                                    Monitor, Respond, and Elevate your Reviews with Ease
                                </MDBox>
                            </MDBox>

                            <MDBox
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    flexDirection: "row", // Always row (icon + text side by side)
                                    mr: 2,
                                    my: 2,
                                    "@media(max-width: 720px)": {
                                        mr: 0,
                                        my: 0,
                                        marginBottom: "10px",
                                        alignItems: "flex-start", // align to top-left
                                    },
                                }}
                            >
                                <MDBox
                                    sx={{
                                        mr: 1,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img src={tickIcon} alt="tick icon" />
                                </MDBox>

                                <MDBox
                                    sx={{
                                        textAlign: "start", // left-align the text
                                        "@media(max-width: 720px)": {
                                            width: "100%",
                                            fontSize: "15px",
                                        },
                                    }}
                                >
                                    Get more Positive Reviews and Boost your Ratings
                                </MDBox>
                            </MDBox>
                            <MDBox
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    flexDirection: "row", // Always row (icon + text side by side)
                                    mr: 2,
                                    my: 2,
                                    "@media(max-width: 720px)": {
                                        mr: 0,
                                        my: 0,
                                        alignItems: "flex-start",
                                        marginBottom: "10px"
                                    },
                                }}
                            >
                                <MDBox
                                    sx={{
                                        mr: 1,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img src={tickIcon} alt="tick icon" />
                                </MDBox>

                                <MDBox
                                    sx={{

                                        textAlign: "start", // left-align the text
                                        "@media(max-width: 720px)": {
                                            width: "100%",
                                            fontSize: "15px",
                                        },
                                    }}
                                >

                                    Grow Revenue and Win Market Share with AI Intelligence
                                </MDBox>
                            </MDBox>



                        </MDBox>
                        <MDBox
                            sx={{
                                position: "absolute",
                                top: "-29px",
                                right: "18px",
                                "@media(max-width: 720px)": {
                                    right: "20px",
                                    top: "-35px",
                                    width: "60px",
                                },
                            }}
                        >
                            <img
                                src={star}
                                alt="star_image"
                                style={{

                                    width: "100%",
                                    height: "auto",
                                }}
                            />
                        </MDBox>
                    </MDBox>
                    <MDBox sx={{
                        display:"none",
                        pt: 20,
                        width: "50%", "@media(max-width: 720px)": {
                            display:"block",
                            width: "100%",
                            pt: 0
                        },
                    }}>
                        <MDTypography
                            sx={{
                                fontSize: "50px",
                                fontWeight: 700,
                                width: "fit-content",
                                margin: "auto",
                                textAlign: "center",
                                "@media(max-width: 720px)": {
                                    mt: 0,
                                    fontSize: "30px",
                                },
                            }}
                        >
                            Try Tavlo For Free!
                        </MDTypography>
                        <MDTypography
                            sx={{
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: 700,
                                lineHeight: "45.36px",
                                "@media(max-width: 720px)": {
                                    display:"none"
                                },
                            }}
                        >
                            Fill the form below to create an account
                        </MDTypography>
                        <MDBox sx={{
                            width: {
                                xs: "100%",  // for extra small screens
                                md: "360px", // for medium and up
                                lg: "475px",
                                xl: "920px"
                            },
                            display: "flex",
                            flexDirection: {
                                xs: "column",  // Mobile
                                md: "column",     // Tablet
                                lg: "column",  // Desktop
                            },
                            gap: {
                                xs: "16px",
                                md: "20px",
                                lg: "30px",
                            },
                            alignItems: {
                                xs: "center",
                                md: "flex-start",
                                lg: "center",
                            },
                            padding: {
                                xs: "20px",
                                md: "20px",
                                lg: "60px",
                                xl: "60px",
                            },
                            justifyContent: "space-between",
                            background: "#D0E5FA", borderRadius: "8px", mt: 2,
                            "@media (min-width: 1080px) and (max-width: 1200px)": {
                                width: "520px",
                                px: 2,
                                py: 4,
                            },
                            "@media (min-width: 1200px) and (max-width: 1440px)": {
                                width: "670px",
                                px: 2,
                                py: 4,
                            },
                        }}>
                            {/* First/ Last  Name */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "30px",
                                    "@media(max-width: 720px)": {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "30px"
                                    },
                                }}
                            >
                            </MDBox>
                            {/* Email */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        placeholder="Email*"
                                        value={values.email}
                                        error={!!errors.email}
                                        onChange={inputHandler("email")}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.email ? (
                                        <MDTypography
                                            px={1}
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: "400",
                                                lineHeight: "15px",
                                            }}
                                            color="error"
                                        >
                                            {errors.email}
                                        </MDTypography>
                                    ) : null}
                                </MDBox>
                            </MDBox>

                            <MDBox
                                item
                                xs={12}
                                lg={12}
                                sx={{ alignSelf: "start", justifyContent: "center" }}
                            >
                                {!isLocalhost && (
                                    <ReCAPTCHA
                                        sitekey="6Ldp3lspAAAAAPZoobA6vLHHHOnWa4eTm9B-GyxB"
                                        onChange={handleCaptchaChange}
                                    />
                                )}
                            </MDBox>
                            {/* Button */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                {!isLocalhost ? (
                                    <>
                                    <MDButton
                                        color="info"
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            background: "#318BEC",
                                            borderRadius: "8px",
                                            color: " #fff",
                                            width: "100%",
                                            "&:hover": {
                                                background: "#318BEC",
                                            },

                                        }}
                                        onClick={() => handleSubmit()}
                                        disabled={!isCaptchaVerified}
                                    >
                                        TRY NOW!
                                    </MDButton>
                                    
                                    <MDButton style={{margin:"auto"}} onClick={() => {setLoading(true); login()}}><img src={icon} alt={"gogole-icon"} style={{ width: 26, height: 26 }} /> Continue with Google</MDButton>
                                    
                                    </>
                                    
                                ) : (
                                    <>
                                       <MDButton
                                        color="info"
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            background: "#318BEC",
                                            borderRadius: "8px",
                                            color: " #fff",
                                            width: "100%",
                                            "&:hover": {
                                                background: "#318BEC",
                                            },
                                        }}
                                        onClick={() => handleSubmit()}
                                    >
                                        TRY NOW!
                                    </MDButton>
                                   
                                    <MDButton style={{margin:"auto"}}  onClick={() => {setLoading(true); login()}}>
                                    <img src={icon} alt={"gogole-icon"} style={{ width: 26, height: 26 }} />
                                       &nbsp; Continue with Google</MDButton>
                                    
                                    </>
                                 
                                )}
                            </MDBox>
                        </MDBox>
                    </MDBox>


                    <MDBox
                        sx={{
                            position: "relative",
                            "@media(max-width: 720px)": {
                                overflow: "hidden", // prevent overflow on mobile
                            },
                        }}
                    >
                        <MDBox
                            sx={{
                                position: "relative",
                                width: "100%",

                            }}
                        >
                            <img
                                src={landingone}
                                alt="landing_image_one"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                    "@media(max-width: 720px)": {
                                        width: "100%",
                                    },
                                }}
                            />
                            <MDBox
                                sx={{

                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    "@media(max-width: 720px)": {
                                        width: "100%",
                                        top: "0px",
                                        right: "0px",
                                    },
                                }}
                            >
                                <img
                                    src={landingtwo}
                                    alt="landing_image_two"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        display: "block",
                                        "@media(max-width: 720px)": {
                                            width: "100%",
                                        },
                                    }}
                                />
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </Box>
            </Box>
        </Container>
        <Box
            sx={{ margin: " auto", position: "relative", "@media (min-width:1580px)": { maxWidth: "1900px!important" } }}
        >
            <MDBox sx={{
                position: "absolute", left: "0px", top: "650px", "@media(max-width: 920px)": {
                    display: "none",
                },
            }} >
                <img src={landingfour} alt="profile_image" />
            </MDBox>
            <MDBox sx={{
                position: "absolute", right: "0px", top: "60px", "@media(max-width: 920px)": {
                    display: "none",
                },
            }} >
                <img src={landingfive} alt="profile_image" />
            </MDBox>
            <MDBox sx={{
                position: "absolute", right: "0px", top: "-420px", "@media(max-width: 920px)": {
                    display: "none",
                },
            }} >
                <img src={ellipse} alt="ellipse" />
            </MDBox>
            {/* section -2 */}
            <Container
                sx={{ "@media (min-width:1580px)": { maxWidth: "1600px!important" } }}
            >
                <Box sx={{
                    display: "flex", gap: 8, alignItems: "start", justifyContent: "space-between",
                    py: 2, "@media(max-width: 720px)": {
                        px: 2,
                        display: "flex",
                        flexDirection: "column"
                    },
                }}>
                    <MDBox sx={{
                        pt: 20,
                        width: "50%", "@media(max-width: 720px)": {
                            width: "100%",
                            pt: 0
                        },
                    }}>
                        <List sx={{ width: "100%" }}>
                            <StyledListItem>
                                <StyledListTextColor>
                                    Boost your review scores, and Grow your Revenue.
                                </StyledListTextColor>
                                <StyledListText>
                                    Get step-by-step strategies to enhance customer experience, boost your review scores, and grow your revenue.
                                </StyledListText>
                            </StyledListItem>
                            <StyledListItem>
                                <StyledListTextColor>
                                    Get More Reviews, Effortlessly
                                </StyledListTextColor>
                                <StyledListText>
                                    Encourage happy customers to share their experience through automated texts, emails, and QR codes—no extra staff effort needed.Seamless Follow-Up, Real Results
                                </StyledListText>
                            </StyledListItem>
                            <StyledListItem>
                                <StyledListTextColor>
                                    Make Your Marketing Work Harder – Attract More Customers
                                </StyledListTextColor>
                                <StyledListText>
                                    Make every marketing dollar bring more customers through your door by leveraging real customer data.           </StyledListText>

                            </StyledListItem>
                            <StyledListItem>
                                <StyledListTextColor>
                                    See All Your Reviews in One Place — Google, Yelp, Facebook & More
                                </StyledListTextColor>
                                <StyledListText>
                                    Easily track what customers are saying across platforms without the hassle of jumping between tabs.
                                </StyledListText>
                            </StyledListItem>
                            <StyledListItem>
                                <StyledListTextColor>
                                    Get Notified of Negative Reviews Instantly
                                </StyledListTextColor>
                                <StyledListText>
                                    Stay ahead of issues before they impact your reputation or revenue.
                                </StyledListText>
                            </StyledListItem>
                            <StyledListItem>
                                <StyledListTextColor>
                                    Respond with Confidence Using AI - Crafted, Personalized Replies
                                </StyledListTextColor>
                                <StyledListText>
                                    Save time while keeping your brand voice warm, professional, and on point.
                                </StyledListText>
                            </StyledListItem>
                        </List>
                    </MDBox>
                    <MDBox sx={{
                        pt: 20,
                        width: "50%", "@media(max-width: 720px)": {
                            display:"none",
                            width: "100%",
                            pt: 0
                        },
                    }}>
                        <MDTypography
                            sx={{
                                fontSize: "50px",
                                fontWeight: 700,
                                width: "fit-content",
                                margin: "auto",
                                textAlign: "center",
                                "@media(max-width: 720px)": {
                                    mt: 0,
                                    fontSize: "30px",
                                },
                            }}
                        >
                            Try Tavlo For Free!
                        </MDTypography>
                        <MDTypography
                            sx={{
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: 700,
                                lineHeight: "45.36px",
                                "@media(max-width: 720px)": {
                                    display:"none"
                                },
                            }}
                        >
                            Fill the form below to create an account
                        </MDTypography>
                        <MDBox sx={{
                            width: {
                                xs: "100%",  // for extra small screens
                                md: "360px", // for medium and up
                                lg: "475px",
                                xl: "920px"
                            },
                            display: "flex",
                            flexDirection: {
                                xs: "column",  // Mobile
                                md: "column",     // Tablet
                                lg: "column",  // Desktop
                            },
                            gap: {
                                xs: "16px",
                                md: "20px",
                                lg: "30px",
                            },
                            alignItems: {
                                xs: "center",
                                md: "flex-start",
                                lg: "center",
                            },
                            padding: {
                                xs: "20px",
                                md: "20px",
                                lg: "60px",
                                xl: "60px",
                            },
                            justifyContent: "space-between",
                            background: "#D0E5FA", borderRadius: "8px", mt: 2,
                            "@media (min-width: 1080px) and (max-width: 1200px)": {
                                width: "520px",
                                px: 2,
                                py: 4,
                            },
                            "@media (min-width: 1200px) and (max-width: 1440px)": {
                                width: "670px",
                                px: 2,
                                py: 4,
                            },
                        }}>
                            {/* First/ Last  Name */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "30px",
                                    "@media(max-width: 720px)": {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "30px"
                                    },
                                }}
                            >
                                {/* First Name */}
                                {/* <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        placeholder="First Name"
                                        value={values.first_name}
                                        error={!!errors.first_name}
                                        onChange={inputHandler("first_name")}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.first_name ? (
                                        <MDBox px={1}>
                                            <MDTypography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: "400",
                                                    lineHeight: "15px",
                                                }}
                                                color="error"
                                            >
                                                {errors.first_name}
                                            </MDTypography>
                                        </MDBox>
                                    ) : null}
                                </MDBox> */}
                                {/* Last Name */}
                                {/* <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        placeholder="Last Name"
                                        value={values.last_name}
                                        error={!!errors.last_name}
                                        onChange={inputHandler("last_name")}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.last_name ? (
                                        <MDBox px={1}>
                                            <MDTypography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: "400",
                                                    lineHeight: "15px",
                                                }}
                                                color="error"
                                            >
                                                {errors.last_name}
                                            </MDTypography>
                                        </MDBox>
                                    ) : null}
                                </MDBox> */}
                            </MDBox>
                            {/* Email */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        placeholder="Email*"
                                        value={values.email}
                                        error={!!errors.email}
                                        onChange={inputHandler("email")}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.email ? (
                                        <MDTypography
                                            px={1}
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: "400",
                                                lineHeight: "15px",
                                            }}
                                            color="error"
                                        >
                                            {errors.email}
                                        </MDTypography>
                                    ) : null}
                                </MDBox>
                            </MDBox>

                            {/* Phone Number */}
                            {/* <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <InputMask
                                        mask="(999) 999-9999"
                                        value={values.phone_number}
                                        disabled={false}
                                        onChange={inputHandler("phone_number")}
                                    >
                                        {() => (
                                            <MDInput
                                                type="text"
                                                placeholder="Phone Number*"
                                                error={!!errors.phone_number}
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        borderRadius: "0px",
                                                        backgroundColor: "#fff",
                                                    },
                                                }}
                                            />
                                        )}
                                    </InputMask>
                                  
                                </MDBox>
                            </MDBox> */}
                            {/* Business Name */}
                            {/* <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        value={values.businessName}
                                        error={!!errors.businessName}
                                        onChange={inputHandler("businessName")}
                                        placeholder="Business Name*"
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.businessName ? (
                                        <MDBox px={1}>
                                            <MDTypography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: "400",
                                                    lineHeight: "15px",
                                                }}
                                                color="error"
                                            >
                                                {errors.businessName}
                                            </MDTypography>
                                        </MDBox>
                                    ) : null}
                                </MDBox>
                            </MDBox> */}
                            {/* Business Address */}
                            {/* <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <MDInput
                                        type="text"
                                        placeholder="Business Address*"
                                        value={values.business_address}
                                        error={!!errors.business_address}
                                        onChange={inputHandler("business_address")}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                borderRadius: "0px",
                                                backgroundColor: "#fff",
                                            },
                                        }}
                                    />
                                    {errors.business_address ? (
                                        <MDBox px={1}>
                                            <MDTypography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: "400",
                                                    lineHeight: "15px",
                                                }}
                                                color="error"
                                            >
                                                {errors.business_address}
                                            </MDTypography>
                                        </MDBox>
                                    ) : null}
                                </MDBox>
                            </MDBox> */}
                            {/* Password */}
                            {/* <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "80px",
                                    flexWrap: "wrap",
                                    "@media(max-width: 720px)": {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "30px",
                                    },
                                }}
                            >
                                <MDBox sx={{ flex: 1 }}>
                                    <MDBox sx={{ position: "relative" }}>
                                        <MDInput
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password*"
                                            value={values.password}
                                            error={!!errors.password}
                                            onChange={inputHandler("password")}
                                            onFocus={() => setTyping(true)}
                                            fullWidth
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    borderRadius: "0px",
                                                    backgroundColor: "#fff",
                                                },
                                            }}
                                        />
                                        <MDBox
                                            sx={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "7px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => eyeButton()}
                                        >
                                            {showPassword ? (
                                                <img src={showHideIcon} alt="icon" />
                                            ) : (
                                                <img src={dontShowIcon} alt="icon" />
                                            )}
                                        </MDBox>
                                    </MDBox>
                                    {errors.password ? (
                                        <MDTypography
                                            px={1}
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: "400",
                                                lineHeight: "15px",
                                            }}
                                            color="error"
                                        >
                                            {errors.password}
                                        </MDTypography>
                                    ) : null}
                                </MDBox>
                                <MDBox sx={{ flex: 1 }}>
                                    {values.password && errors.password === "" ? (
                                        <>
                                            <MDBox sx={{ position: "relative" }}>
                                                <MDInput
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder="Confirm Password*"
                                                    value={values.confirmPassword}
                                                    error={!!errors.confirmPassword}
                                                    onChange={inputHandler("confirmPassword")}
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            borderRadius: "0px",
                                                            backgroundColor: "#fff",
                                                        },
                                                    }}
                                                />
                                                <MDBox
                                                    sx={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "7px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => eyeButton2()}
                                                >
                                                    {showConfirmPassword ? (
                                                        <img src={showHideIcon} alt="icon" />
                                                    ) : (
                                                        <img src={dontShowIcon} alt="icon" />
                                                    )}
                                                </MDBox>
                                            </MDBox>
                                            {errors.confirmPassword ? (
                                                <MDTypography
                                                    px={1}
                                                    sx={{
                                                        fontSize: "13px",
                                                        fontWeight: "400",
                                                        lineHeight: "15px",
                                                    }}
                                                    color="error"
                                                >
                                                    {errors.confirmPassword}
                                                </MDTypography>
                                            ) : null}
                                        </>
                                    ) : null}
                                </MDBox>
                            </MDBox>
                            {typing ? (
                                <MDBox className="password-validations" sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start" }}>
                                    <MDBox sx={{ my: 2, px: 1 }}>
                                        <MDBox sx={{
                                            display: "flex", justifyContent: "start", alignItems: "center", "@media(max-width: 720px)": {
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                gap: "10px",
                                                width: "100%"
                                            },
                                        }}>
                                            <MDBox sx={{ mr: 0.5 }}>
                                                <img
                                                    src={
                                                        isLongEnough(values.password)
                                                            ? correctIcon
                                                            : wrongIcon
                                                    }
                                                />
                                            </MDBox>
                                            <Typography
                                                className={
                                                    isLongEnough(values.password)
                                                        ? "password-checker-after"
                                                        : "password-checker-before"
                                                }
                                            >
                                                Must be at least 8 characters long
                                            </Typography>
                                        </MDBox>
                                        <MDBox sx={{
                                            display: "flex", justifyContent: "start", alignItems: "center", "@media(max-width: 720px)": {
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                gap: "10px",
                                                width: "100%"
                                            },
                                        }}>
                                            <MDBox sx={{ mr: 0.5 }}>
                                                <img
                                                    src={
                                                        isLongEnough(values.password)
                                                            ? correctIcon
                                                            : wrongIcon
                                                    }
                                                />
                                            </MDBox>
                                            <Typography
                                                className={
                                                    hasUpperCase(values.password)
                                                        ? "password-checker-after"
                                                        : "password-checker-before"
                                                }
                                            >
                                                Include at least 1 uppercase letter
                                            </Typography>
                                        </MDBox>
                                        <MDBox sx={{
                                            display: "flex", justifyContent: "start", alignItems: "center", "@media(max-width: 720px)": {
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                gap: "10px",
                                                width: "100%"
                                            },
                                        }}>
                                            <MDBox sx={{ mr: 0.5 }}>
                                                <img
                                                    src={
                                                        isLongEnough(values.password)
                                                            ? correctIcon
                                                            : wrongIcon
                                                    }
                                                />
                                            </MDBox>
                                            <Typography
                                                className={
                                                    hasLowerCase(values.password)
                                                        ? "password-checker-after"
                                                        : "password-checker-before"
                                                }
                                            >
                                                Include at least 1 lowercase letter
                                            </Typography>
                                        </MDBox>
                                        <MDBox sx={{
                                            display: "flex", justifyContent: "start", alignItems: "center", "@media(max-width: 720px)": {
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                gap: "10px",
                                                width: "100%"
                                            },
                                        }}>
                                            <MDBox sx={{ mr: 0.5 }}>
                                                <img
                                                    src={
                                                        isLongEnough(values.password)
                                                            ? correctIcon
                                                            : wrongIcon
                                                    }
                                                />
                                            </MDBox>
                                            <Typography
                                                className={
                                                    hasNumber(values.password)
                                                        ? "password-checker-after"
                                                        : "password-checker-before"
                                                }
                                            >
                                                Include at least 1 number
                                            </Typography>
                                        </MDBox>
                                        <MDBox sx={{
                                            display: "flex", justifyContent: "start", alignItems: "center", "@media(max-width: 720px)": {
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                gap: "10px",
                                                width: "100%"
                                            },
                                        }}>
                                            <MDBox sx={{ mr: 0.5 }}>
                                                <img
                                                    src={
                                                        isLongEnough(values.password)
                                                            ? correctIcon
                                                            : wrongIcon
                                                    }
                                                />
                                            </MDBox>
                                            <Typography
                                                className={
                                                    hasSpecialChar(values.password)
                                                        ? "password-checker-after"
                                                        : "password-checker-before"
                                                }
                                            >
                                                Include at least 1 special character (!@#$%^&*){" "}
                                            </Typography>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            ) : null} */}
                            <MDBox
                                item
                                xs={12}
                                lg={12}
                                sx={{ alignSelf: "start", justifyContent: "center" }}
                            >
                                {!isLocalhost && (
                                    <ReCAPTCHA
                                        sitekey="6Ldp3lspAAAAAPZoobA6vLHHHOnWa4eTm9B-GyxB"
                                        onChange={handleCaptchaChange}
                                    />
                                )}
                            </MDBox>
                            {/* Button */}
                            <MDBox
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                }}
                            >
                                {!isLocalhost ? (
                                    <>
                                    <MDButton
                                        color="info"
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            background: "#318BEC",
                                            borderRadius: "8px",
                                            color: " #fff",
                                            width: "100%",
                                            "&:hover": {
                                                background: "#318BEC",
                                            },

                                        }}
                                        onClick={() => handleSubmit()}
                                        disabled={!isCaptchaVerified}
                                    >
                                        TRY NOW!
                                    </MDButton>
                                    
                                    <MDButton style={{margin:"auto"}} onClick={() => {setLoading(true); login()}}><img src={icon} alt={"gogole-icon"} style={{ width: 26, height: 26 }} /> Continue with Google</MDButton>
                                    
                                    </>
                                    
                                ) : (
                                    <>
                                       <MDButton
                                        color="info"
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            background: "#318BEC",
                                            borderRadius: "8px",
                                            color: " #fff",
                                            width: "100%",
                                            "&:hover": {
                                                background: "#318BEC",
                                            },
                                        }}
                                        onClick={() => handleSubmit()}
                                    >
                                        TRY NOW!
                                    </MDButton>
                                   
                                    <MDButton style={{margin:"auto"}}  onClick={() => {setLoading(true); login()}}>
                                    <img src={icon} alt={"gogole-icon"} style={{ width: 26, height: 26 }} />
                                       &nbsp; Continue with Google</MDButton>
                                    
                                    </>
                                 
                                )}
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </Box>
                {/* section -3 */}
                <Box sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    py: 16, "@media(max-width: 720px)": {
                        px: 2,
                        py: 8,
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px"
                    },
                }}>
                    <MDBox
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            "@media (max-width: 720px)": {
                                justifyContent: "center",
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={dashboardHero}
                            alt="dashboard"
                            sx={{
                                width: {
                                    xs: "100%",
                                    md: "320px",
                                    lg: "475px"
                                },
                                height: {
                                    xs: "100%",
                                    md: "220px",
                                    lg: "309px"
                                },
                                "@media (min-width: 920px) and (max-width: 1200px)": {
                                    width: "380px",
                                },
                            }}
                        />
                    </MDBox>
                    <MDBox
                        sx={{
                            width: "65%",
                            position: "relative",

                            "@media (max-width: 720px)": {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                gap: "40px"
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={composeAdorn}
                            alt="aggregate platform metrics"
                            sx={{
                                display: "block",
                                boxShadow: "0px 0px 22px 5.48px #5F5F5F24",
                                borderRadius: "8px",
                                width: {
                                    xs: "100%",
                                    md: "420px",
                                    lg: "100%"
                                },
                                height: {
                                    xs: "100%",
                                    md: "220px",
                                    lg: "293px"
                                },
                                "@media (min-width: 920px) and (max-width: 1200px)": {
                                    width: "420px",
                                    height: "208px"
                                },
                                "@media  (max-width: 720px)": {
                                    width: "320px",
                                    height: "208px"
                                },
                            }}
                        />
                        <MDBox sx={{
                            position: "absolute", top: "-45%", right: "0",
                            boxShadow: "0px 0px 22px 5.48px rgba(95, 95, 95, 0.14)", borderRadius: "12px",
                            "@media  (max-width: 720px)": {
                                display: "none",
                                boxShadow: "none",
                                position: "relative",
                                border: "1px solid red"
                            },
                        }}>
                            <img src={agrRev1}
                                alt="TavloAI"
                                sx={{
                                    width: "244px   ",
                                    height: "155px", display: "block",
                                    boxShadow: "0px 0px 22px 5.48px rgba(95, 95, 95, 0.14)",
                                    borderRadius: "12px",
                                    objectFit: "cover", "@media  (max-width: 720px)": {
                                        marginLeft: "20px",
                                        width: "100%",
                                        height: "208px"
                                    },
                                }}
                            />
                        </MDBox>
                    </MDBox>
                </Box>
            </Container>
        </Box>
        <Footer />
    </>
    )
}
export default Landing
